import { StepEvent } from '@samelogic/steps';
import { ConfigTreeNode } from '../models';

export function getDependencyConfigKeys(
  configTree: Map<string, ConfigTreeNode>,
  stepEvent: StepEvent
): string[] {
  const keys: string[] = [];
  for (const [key, value] of Array.from(configTree.entries())) {
    if (!value.config.needs) continue;
    if (value.config.needs?.name === stepEvent.stepName && value.config.needs.event === stepEvent.event) {
      keys.push(key);
    }
  }
  return keys;
}
